/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';
  //grabbed old models from iphone_14.es5.js
  var old_models = [
    mp.marketing.trends.utils.IPHONE_14,
		mp.marketing.trends.utils.IPHONE_14_PLUS,
    mp.marketing.trends.utils.IPHONE_14_PRO,
    mp.marketing.trends.utils.IPHONE_14_PRO_MAX,
    mp.marketing.trends.utils.OTHER_IPHONE,
  ];
  var release_models = [
    mp.marketing.trends.utils.IPHONE_15,
		mp.marketing.trends.utils.IPHONE_15_PLUS,
    mp.marketing.trends.utils.IPHONE_15_PRO,
    mp.marketing.trends.utils.IPHONE_15_PRO_MAX,
  ];
  var IPhone15 = mp.marketing.trends.widgets.PhoneAdoption.extend({
    get_display_models() {
      return release_models.concat(old_models);
    },
    get_release_models() {
      return release_models;
    },
    get_visible_models() {
      return release_models.concat(old_models.slice(0, 3));
    },
    get_query_name() {
      return mp.marketing.trends.utils.IPHONE_QUERY;
    },
    getDownloadName() {
      return ns.IPhone15.nice_name;
    },
  });

  Object.assign(IPhone15, {
    slug: `iphone_15`,
    nice_name: `iPhone 15 adoption`,
    description: `How quickly will people start using the new iPhone 15 models?`,
  });
  ns.IPhone15 = IPhone15;
});

}.call(window));